import {Directive, Input, SimpleChanges, Renderer2, ElementRef, OnChanges} from '@angular/core';

@Directive({
  selector: '[appSearchHighlight]'
})
export class SearchHighlightDirective implements OnChanges {

  @Input() searchedWords: string[];
  @Input() classToApply: string;

  private _text = '';

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @Input() set text(newText: string) {
    let modText = newText;
    if (!!!modText) {
      modText = '';
    }
    this._text = modText;
  }

  get text() {
    return this._text;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.searchedWords || !this.searchedWords.length || !this.classToApply) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.text);
      return;
    }

    this.renderer.setProperty(
      this.el.nativeElement,
      'innerHTML',
      this.getFormattedText()
    );
  }

  getFormattedText() {
    const escaped = this.searchedWords.map((searchTerm) => {
      return searchTerm.replace('\\', '\\\\');
    });
    const re = new RegExp(`(${escaped.join('|')})`, 'gi');

    if (!this.text) {
      return '';
    }
    return this.text.replace(re, `<span class="${this.classToApply}">$1</span>`);
  }

}
